import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { getFilteredTourSteps } from './tourData';

const DashboardTour = ({ autoStart = false, onComplete }) => {
  const { startTour } = useShepherdTour('dashboard', getFilteredTourSteps('dashboard'), autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Dashboard Tour
    </button> */}
    </>
  );
};

export default DashboardTour;
